import { mapGetters, mapMutations } from 'vuex';
import { MEDIA } from '@/helpers/variables';
import IconMessengerOpen from '@/components/icons/IconMessengerOpen.vue';
import IconMessengerClose from '@/components/icons/IconMessengerClose.vue';
import IconViber from '@/components/icons/IconViber.vue';
import IconTelegram from '@/components/icons/IconTelegram.vue';

export default {
  name: 'MessengerBlock',
  components: { IconTelegram, IconViber, IconMessengerClose, IconMessengerOpen },
  props: {},
  data() {
    return {
      MEDIA,
      isShowSocials: false
    };
  },

  created() {},

  computed: {
    ...mapGetters({
      contacts: 'setting/variables',
      appSize: 'app/size'
    }),
    messengers() {
      return this.contacts?.messengers ? this.contacts.messengers : {};
    }
  },
  methods: {
    ...mapMutations({
      modalOpen: 'app/MODAL_OPEN'
    }),
    onShowSocials() {
      this.isShowSocials = !this.isShowSocials;
    },
    onOpenFeedbackModal() {
      this.modalOpen('messengerModal');
    }
  }
};
